module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap"
  }, [_c('rotate-detect'), _vm._v(" "), _c('div', {
    staticClass: "topbar"
  }), _vm._v(" "), _c('div', {
    staticClass: "rightbar"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('nav-bar', {
    attrs: {
      "nav": _vm.showNav
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "artistpage"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('svg', {
    staticClass: "svg100",
    attrs: {
      "ratio": "0.25",
      "fill": "#ffffff",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 1920 480"
    }
  }, [_c('title', [_vm._v("blockwhite")]), _c('polygon', {
    attrs: {
      "points": "1920 0 0 480 0 0 1920 0"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "max1000"
  }, [_c('a', {
    staticClass: "arrow_back",
    attrs: {
      "href": "/#/?from_artist",
      "onclick": "gaclick('btn_artist_back')"
    }
  }, [_c('svg', {
    staticClass: "arrowtop",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 33.86 18.28"
    }
  }, [_c('title', [_vm._v("top")]), _c('path', {
    attrs: {
      "d": "M33.38,15.63,16,.39a1.57,1.57,0,0,0-2.58,1.15Q7.08,8.78.42,15.73c-1.33,1.38.77,3.49,2.1,2.1Q9.12,11,15.37,3.8l15.9,13.94C32.71,19,34.82,16.9,33.38,15.63Z"
    }
  })]), _vm._v(" "), _c('svg', {
    staticClass: "arrowbg",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 90.86 93.28"
    }
  }, [_c('title', [_vm._v("btn")]), _c('path', {
    attrs: {
      "d": "M0,48.67C-.06,29,12.8,9.5,31,1.79c12.47-5.27,33.3,1.68,39.81,13.45C73.66,20.35,78,24,82.3,27.59c3,2.52,4.79,5.39,4.3,9.48-.39,3.29,1,6.16,2.46,9a15.11,15.11,0,0,1,.18,14c-12.18,25.24-30,34.78-54.36,33a16,16,0,0,1-8.06-2.36C11.93,80.51,0,68.37,0,48.67Z"
    }
  })])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _c('a', {
    staticClass: "btn wow4 fadeInUp",
    attrs: {
      "href": "javascript:void(0)",
      "onclick": "trackWaitJump('btn_moreworks_linjiaxuan','https://taiwancurio.wordpress.com/category/%E6%9E%97%E4%BD%B3%E7%91%84/')"
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 41.24 35.64"
    }
  }, [_c('title', [_vm._v("read")]), _c('path', {
    attrs: {
      "d": "M36.64,0H23.83a4.64,4.64,0,0,0-3.2,1.33A4.64,4.64,0,0,0,17.42,0H4.6A4.67,4.67,0,0,0,0,4.6V27.83a4.67,4.67,0,0,0,4.6,4.6H17.42a1.78,1.78,0,0,1,1.8,1.8,1.4,1.4,0,0,0,1.4,1.4,1,1,0,0,0,.41-.07,1.28,1.28,0,0,0,.82-.63,1.25,1.25,0,0,0,.17-.7,1.78,1.78,0,0,1,1.8-1.8H36.64a4.67,4.67,0,0,0,4.6-4.6V4.6A4.67,4.67,0,0,0,36.64,0ZM22,4.6a1.78,1.78,0,0,1,1.8-1.8H36.64a1.78,1.78,0,0,1,1.8,1.8V27.83a1.78,1.78,0,0,1-1.8,1.8H23.83A4.18,4.18,0,0,0,22,30Zm-2.8,0V30a4.18,4.18,0,0,0-1.8-.41H4.6a1.78,1.78,0,0,1-1.8-1.8V4.6A1.78,1.78,0,0,1,4.6,2.8H17.42A1.78,1.78,0,0,1,19.22,4.6Z"
    }
  })])]), _c('span', [_vm._v("更多佳瑄的事")])])])]), _vm._v(" "), _c('div', {
    staticClass: "switchbtn"
  }, [_c('router-link', {
    staticClass: "btn artist1",
    attrs: {
      "to": "/artist1"
    }
  }, [_c('p', [_c('span', [_vm._v("創作人/")]), _c('b', [_vm._v("吳柏均")])])]), _c('router-link', {
    staticClass: "btn artist3",
    attrs: {
      "to": "/artist3"
    }
  }, [_c('p', [_c('span', [_vm._v("創作人/")]), _c('b', [_vm._v("高健騰")])])])], 1)])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookmark"
  }, [_c('img', {
    attrs: {
      "src": require("../asset/svg/bookmark/v/artist.svg"),
      "alt": "多寶創作人"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "artistdescription wow1 fadeInUp"
  }, [_c('img', {
    attrs: {
      "src": require("../img/artist/artistpage2.svg"),
      "alt": "美是一種本能"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "artistinfo"
  }, [_c('div', {
    staticClass: "artistpic wow1 fadeInUp"
  }, [_c('img', {
    attrs: {
      "src": require("../img/artist/artist02.jpg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "txtcontent strip"
  }, [_c('h2', {
    staticClass: "wow2 fadeInUp"
  }, [_c('span', [_vm._v("創作人/")]), _c('b', [_vm._v("林佳瑄")])]), _vm._v(" "), _c('p', {
    staticClass: "wow3 fadeInUp"
  }, [_vm._v("四歲時的佳瑄，每到一個新的空間常哭鬧不停。出門更是困難，一定要選到她滿意的衣服、裙褲、鞋子，包括顏色的搭配才願意出門。所有的孩子，只有她看到韓老師換了新的背包，還要老師背起來，轉身換角度讓她欣賞。時間讓一個孩子長大，但天生的本質一直在，延伸對時尚造型彩妝的興趣，生活的基本是要漂亮、好看。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "worklist"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "featurepic wow1 fadeInUp"
  }, [_c('img', {
    attrs: {
      "src": require("../img/artist/work02_1.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "wow2 fadeInUp"
  }, [_vm._v("喜馬拉雅藍罌粟")]), _vm._v(" "), _c('p', {
    staticClass: "wow3 fadeInUp"
  }, [_vm._v("27.2(L) x 39.3(M)cm (8K) 水彩 2016.")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "featurepic wow1 fadeInUp"
  }, [_c('img', {
    attrs: {
      "src": require("../img/artist/work02_2.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "wow2 fadeInUp"
  }, [_vm._v("林佳瑄自畫像")]), _vm._v(" "), _c('p', {
    staticClass: "wow3 fadeInUp"
  }, [_vm._v("54.5(L) x 39.3(M)cm (4K) 鉛筆 2015.")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "featurepic wow1 fadeInUp"
  }, [_c('img', {
    attrs: {
      "src": require("../img/artist/work02_3.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "wow2 fadeInUp"
  }, [_vm._v("紫丁香")]), _vm._v(" "), _c('p', {
    staticClass: "wow3 fadeInUp"
  }, [_vm._v("27.2(L) x 39.3(M)cm (8K) 水彩 2016.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12438803"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Artist2.vue
// module id = 238
// module chunks = 0